"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassName = function (defaultClassName, className) {
    return className
        ? className
            .split(' ')
            .concat(defaultClassName)
            .join(' ')
        : defaultClassName.join(' ');
};
//# sourceMappingURL=classname.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapbox-gl/lib/util/classname.js
// module id = 125
// module chunks = 1135276415346 35783957827783 89888082226891